export const events = {
  eventsCardDurationText: 'длит.',
  eventsSearchInputText: 'Поиск',
  eventsRegisteredToEventAlertTitle: 'Зарегистрировано!',
  eventsUnregisteredToEventAlertTitle: 'Регистрация отменена!',
  eventsExternalRegistrationPopupTitle: 'Регистрация',
  eventsExternalRegistrationPopupContent: 'Удалось зарегистрироваться по внешней ссылке?',
  eventsExternalRegistrationNoButtonTitle: 'Нет',
  eventsExternalRegistrationYesButtonTitle: 'Да',
  eventsCurtainCopyOptionTitle: 'Скопировать ссылку',
  eventsCurtainFlagOptionTitle: 'Пожаловаться',
  eventsLinkCopiedAlertText: 'Ссылка скопирована!',
  eventsCurtainAddToCalendOptionTitle: 'Добавить в календарь',
  eventdetailsAgendaButtonTitle: 'Агенда',
  eventdetailsOnMapButtonTitle: 'На карте',
  eventdetailsOnlineLocationTitle: 'Онлайн',
  eventdetailAmountsRegisteredText: 'участников',
  eventdetailsSeeAllButtonTitle: 'Все',
  eventdetailsRegisteredButtonTitle: 'Зарегистрирован(а)',
  eventdetailsRegisterButtonTitle: 'Зарегистрироваться',
  eventdetailsRegisteredAlertText: 'Зарегистрировано!',
  eventdetailsUnregisteredAlertText: 'Регистрация отменена!',
  eventdetailsAgendaTitle: 'Агенда',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Зарегистрированные',
  eventdetailsSpeakersCurtainTitle: 'Спикеры',
  eventdetailsSpeakersSectionTitle: 'Спикеры',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Все',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Все',
  eventdetailsCurtainCopyOptionTitle: 'Скопировать ссылку',
  eventdetailsCurtainFlagOptionTitle: 'Пожаловаться',
  eventsdetailsLinkCopiedAlertText: 'Ссылка скопирована!',
  eventdetailsCurtainAddToCalOptionTitle: 'Добавить в календарь',
  eventDetailsAddCalendarPopupTitle: 'Календарь',
  eventdetailsAddCalendarPopupContent: 'Добавить в календарь?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Нет',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Да',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Скопировать ссылку',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Пожаловаться',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Ссылка скопирована!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Скопировать ссылку',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Пожаловаться',
  eventsFlag: 'Пожаловаться',
  eventsJoin: 'Перейти',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Ссылка скопирована!',
  eventContentReported: 'Жалоба отправлена',
  eventsError: 'Что-то пошло не так!',
  eventdetailsExternalRegistrationPopupContent: 'Удалось зарегистрироваться по внешней ссылке?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Нет',
  eventdetailsExternalRegistrationYesButtonTitle: 'Да',
  eventdetailsExternalRegistrationPopupTitle: 'Регистрация',
  eventsCardRegisteredButtonTitle: 'Зарегистрирован(а)',
  eventsCardRegisterButtonTitle: 'Зарегистрироваться',
  eventsJoinLink: 'Ссылка на присоединение к событию: [url]{link}[/url][br]',
  eventsGuest: 'Гость',
  eventsNoSessionInDay: 'Нет событий в указанную дату.',
  eventsShowUpcomingEvent: 'Показать ближайшее событие'
}
